<template>
    <v-layout class="mt-3">
        <v-flex xs12>
            <v-card class="mx-aut" flat>
                <confirmation-header-text :text="$vuetify.lang.t('$vuetify.relationship_person_detail')" class="ml-2"
                                          icon="mdi-account-multiple"/>

                <v-card-text>
                    <v-layout class row>
                        <v-flex xs12 sm4 class="pr-2">
                            <v-autocomplete
                                :items="relationship_options"
                                :rules="[rules.required]"
                                label="Relationship of Nepalese kin with the applicant *"
                                outlined
                                v-model="visa.extra.application_data.relation"
                            />
                        </v-flex>
                        <v-flex xs12 sm4 class="pr-2">
                            <v-autocomplete
                                :items="genders"
                                :rules="[rules.required]"
                                item-text="name"
                                item-value="id"
                                label="Gender *"
                                outlined
                                v-model="visa.extra.application_data.gender"
                            />
                        </v-flex>

                        <v-flex xs12 sm4 class="pr-2">
                            <v-text-field
                                :label="$vuetify.lang.t('$vuetify.full_name') + '*'"
                                outlined
                                type="text"
                                v-model="visa.extra.application_data.full_name"
                            />
                        </v-flex>
                        <v-flex xs12 sm4 class="pr-2">
                            <address-auto-complete
                                :label="$vuetify.lang.t('$vuetify.full_address') + ' *'"
                                country-code="np"
                                v-model="visa.extra.application_data.full_address"
                            />
                        </v-flex>
                        <v-flex class="pr-2" xs12 sm4>
                            <v-text-field
                                :label="$vuetify.lang.t('$vuetify.citizenship_number') + ' *'"
                                outlined
                                type="text"
                                v-model="visa.extra.application_data.citizenship_number"
                            />
                        </v-flex>
                        <v-flex class="pl-3 pr-2" xs12 sm4>
                            <date-picker-nepali
                                v-model="visa.extra.application_data.dob"
                                label="Date of birth (BS)"
                                :min-year="dob.min_year"
                                :max-year="dob.max_year"
                            />
                        </v-flex>

                    </v-layout>
                </v-card-text>

            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import AddressAutoComplete from "../../AddressAutoComplete";
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";
    import DatePicker from "../../DatePicker";
    import FileInput from "../../FileInput";
    import {mapGetters,} from 'vuex';
    import {fetchDynamicValues} from "../../../helpers/dynamicValueHelper";
    import DatePickerNew from "../../DatePickerNew";
    import DatePickerNepali from "../../DatePickerNepali";

    export default {
        data: () => ({
            genders: ['Male', 'Female'],
            rules: {
                required: value => !!value || "Required."
            },
            relationship_options: [],
            options: [
                {
                    text: "Nepal",
                    value: "Nepal"
                },
                {
                    text: "Abroad",
                    value: "Abroad"
                }
            ]
        }),
        components: {
            DatePickerNepali,
            DatePickerNew,
            DatePicker,
            FileInput, ConfirmationHeaderText,
            "address-auto-complete": AddressAutoComplete
        },
        computed: {
            ...mapGetters("DynamicValues", ["relations"]),
            visa() {
                return this.$store.state.VisaSingle.visa;
            },
            dob() {
                let max_year = new Date().toISOString().substr(0, 4);
                max_year = parseInt(max_year) + 56;

                const min_year = max_year - 120;
                return {
                    min_year,
                    max_year
                }
            },

        },
        methods: {
            addressChanged(e) {
                this.visa.extra.application_data.address = e;
            },
            getDynamicLabel(text) {
                if (this.visa.extra.application_data.full_name) {
                    return text + ' of ' + this.visa.extra.application_data.full_name + ' *'
                } else if (this.visa.extra.application_data.married_to) {
                    return text + ' of ' + this.visa.extra.application_data.married_to + ' *'
                } else {
                    return text + ' of Husband/Wife *'
                }

            },
        },
        mounted() {
            fetchDynamicValues('Relations').then((data) => {
                this.relationship_options = data;
            })
        }
    };
</script>

<style>
</style>
